import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'error.default.title',
    defaultMessage: 'Ada yang salah nih',
  },
  desc: {
    id: 'error.default.desc',
    defaultMessage:
      'Sepertinya terjadi kesalahan dengan sistem kami. Silakan coba lagi.',
  },
  btnOk: {
    id: 'btn.ok',
    defaultMessage: 'OK',
  },
  btnCancel: {
    id: 'btn.cancel',
    defaultMessage: 'Cancel',
  },
});
